import React, { useEffect, useState } from "react";
import { X, Truck, Loader2 } from "lucide-react";
import api from "@/utils/api";

export default function DelhiveryTransitModal({ awb, open, onClose }) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open || !awb) return;
    setLoading(true);
    setError(null);
    setData(null);
    api.get(`/v2/tracking/${awb}/raw-delhivery`)
      .then((res) => setData(res.data))
      .catch((e) => setError(e.response?.data?.detail || "Failed to load Delhivery transit history"))
      .finally(() => setLoading(false));
  }, [open, awb]);

  if (!open) return null;

  const scans = data?.scans || [];
  const formatDate = (dt) => {
    if (!dt) return "—";
    try {
      return new Date(dt).toLocaleString("en-IN", {
        day: "2-digit", month: "short", year: "numeric",
        hour: "2-digit", minute: "2-digit", hour12: true,
      });
    } catch {
      return dt;
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4" onClick={onClose}>
      <div className="w-full max-w-lg rounded-xl bg-white shadow-xl max-h-[85vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between border-b px-5 py-4 shrink-0">
          <div>
            <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
              <Truck className="w-5 h-5 text-indigo-600" /> Delhivery Transit History
            </h2>
            <p className="text-xs text-gray-400 font-mono mt-0.5">AWB: {awb}</p>
          </div>
          <button onClick={onClose} className="rounded-full p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600">
            <X size={20} />
          </button>
        </div>

        <div className="overflow-y-auto px-5 py-4 flex-1">
          {loading && (
            <div className="flex items-center justify-center py-10 text-gray-400 gap-2">
              <Loader2 className="w-5 h-5 animate-spin" /> Fetching live from Delhivery...
            </div>
          )}
          {error && !loading && (
            <p className="text-sm text-red-500 py-4">{error}</p>
          )}
          {!loading && !error && scans.length === 0 && (
            <p className="text-sm text-gray-400 py-4">No scan history available yet.</p>
          )}
          {!loading && !error && scans.length > 0 && (
            <div className="relative pl-6">
              <div className="absolute left-[7px] top-1 bottom-1 w-px bg-slate-200" />
              {scans.map((s, i) => {
                const isLast = i === scans.length - 1;
                return (
                  <div key={i} className="relative pb-6 last:pb-0">
                    <div
                      className={`absolute -left-6 top-0.5 w-3.5 h-3.5 rounded-full border-2 ${
                        isLast ? "bg-indigo-600 border-indigo-600" : "bg-white border-slate-300"
                      }`}
                    />
                    <p className={`text-sm font-semibold ${isLast ? "text-indigo-700" : "text-slate-700"}`}>
                      {formatDate(s.scan_datetime)}
                    </p>
                    <p className={`text-sm mt-0.5 ${isLast ? "text-indigo-600 font-medium" : "text-slate-600"}`}>
                      {s.activity}
                    </p>
                    {s.location && (
                      <p className="text-xs text-slate-400 mt-0.5">{s.location}</p>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div className="border-t px-5 py-3 text-right shrink-0">
          <button onClick={onClose} className="rounded-lg bg-gray-100 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-200">
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
